<!-- EnvironmentCheckPercentileValue.vue -->
<script setup lang="ts">
    import { computed } from 'vue';
    import { EnvironmentCheckPercentiles } from '../../lib/Api/CustomerSupport';
    import { EnvironmentCheckPercentileType, getValuePercentile } from './EnvironmentCheck';
    import { MessageBadge } from '../../LibMain';
    import { DisplayStyle } from '../../Enums/UiEnums';

    const props = defineProps<{
        value?: any,
        percentiles?: EnvironmentCheckPercentiles
    }>();

    const percentile = computed<EnvironmentCheckPercentileType | undefined>(() => 
            typeof(props.value) ? getValuePercentile(Number(props.value), props.percentiles) : undefined);

    const percentileToolTip = computed<string>(()=>
        `Median: ${props.percentiles?.median}\n`+
        `75th Percentile: ${props.percentiles?.top75Percent}\n`+
        `90th Percentile: ${props.percentiles?.top90Percent}\n`+
        `95th Percentile: ${props.percentiles?.top95Percent}\n`);
</script>

<template>
    {{ value }}
    <template v-if="percentile === EnvironmentCheckPercentileType.Top50Percentile">
        <MessageBadge :title="percentileToolTip">
            >Median
        </MessageBadge>
    </template>
    <template v-if="percentile === EnvironmentCheckPercentileType.Top75Percentile">
        <MessageBadge :displayStyle="DisplayStyle.Warning" :title="percentileToolTip">
            >75%
        </MessageBadge>
    </template>
    <template v-if="percentile === EnvironmentCheckPercentileType.Top90Percentile">
        <MessageBadge :displayStyle="DisplayStyle.Danger" :title="percentileToolTip">
            >90% (Poor)
        </MessageBadge>
    </template>
    <template v-if="percentile === EnvironmentCheckPercentileType.Top95Percentile">
        <MessageBadge :displayStyle="DisplayStyle.Danger" :title="percentileToolTip">
            >95% (Very poor)
        </MessageBadge>
    </template>
</template>